import { useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { MARKS, BLOCKS } from "@contentful/rich-text-types";
import map from "../images/map.png";
import Line from "../images/brush-hr.svg";
import FullPageLoader from "../components/FullPageLoader";

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <span className="fw-bold">{text}</span>,
    [MARKS.ITALIC]: (text) => <span className="i">{text}</span>,
  },
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => (
      <img
        className="w-75 m-auto"
        src={node.data?.target?.fields?.file?.url}
        alt={node.data?.target?.fields?.title}
      />
    ),
  },
};

const Benvenuti = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Benvenuti a Auburn Road!";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  // Get fields from Contentful
  const fields = info.fields;

  // Get images from Contentful
  const julesScottImage = fields.mainImage.fields.file.url;

  const mapImage = map;
  const reelImage = fields.reelImage ? fields.reelImage.fields.file.url : null;

  return (
    <div className="container p-t-100 p-b-200">
      <h1 className="huge-text-no-quote text-center mb-5">
        Benvenuti a Auburn Road!
      </h1>

      {/* Top Section: Photo and Text */}
      <div className="d-flex flex-md-row flex-column gap-5">
        <div className="d-flex flex-column m-t-50">
          {julesScottImage && (
            <img
              src={julesScottImage}
              alt="Jules & Scott"
              className="width-300"
              style={{ borderRadius: "8px" }}
            />
          )}
        </div>
        <div className="inner-container  p-t-50">
          {documentToReactComponents(fields.mainContent, options)}
        </div>
      </div>

      {/* Middle Section: Map and Reel */}
      <div className="row m-t-100 mb-5">
        <div className="col-lg-6 col-md-12 mb-4">
          {mapImage && (
            <img
              src={mapImage}
              alt="Map showing location"
              className="width-300"
            />
          )}
          {fields.mapCaption && (
            <p className="text-muted mt-2">{fields.mapCaption}</p>
          )}
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="position-relative">
            <iframe
              width="100%"
              height="715"
              src="https://youtube.com/embed/N--NRgbUOgk?si=YvH6OK_0V0uZ1wdb"
              frameborder="0"
              allowfullscreen
              title="cowtown video"
            ></iframe>
            {fields.reelCaption && (
              <p className="text-muted mt-2">{fields.reelCaption}</p>
            )}
          </div>
        </div>
      </div>

      {/* Wines Section */}
      {fields.availableWines && fields.availableWines.length > 0 && (
        <div className="m-t-100">
          <img className="width-100 m-auto m-t-20 m-b-50" src={Line} alt="" />
          <h2 className="m-b-30">Wines currently available in Italy</h2>
          <div>
            {fields.availableWines.map((wine, index) => (
              <div key={index} className="wine-item-list mb-4">
                <div className="d-flex align-items-start">
                  <div>
                    <img
                      className="width-100 me-3"
                      src={wine.fields.wineArt.fields.file.url}
                    />
                  </div>
                  <div className="wine-item-content flex-1">
                    <h3 className="m-b-10">
                      {wine.fields.wineName || `Wine ${index + 1}`}
                    </h3>
                    {wine.fields.description}
                  </div>
                </div>
                {index < fields.availableWines.length - 1 && (
                  <img className="width-50 m-t-20" src={Line} alt="" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Email Signup Section */}
      {fields.emailSignup && (
        <div className="m-t-100 text-center">
          <img className="width-100 m-auto m-t-20 m-b-50" src={Line} alt="" />
          <h2 className="m-b-20">Join our Email</h2>
          {documentToReactComponents(fields.emailSignup, options)}
        </div>
      )}
    </div>
  );
};

export default Benvenuti;
